<template>
  <div class="form-area" v-loading="submitLoading">
    <!-- 步骤条 -->
    <div class="steps-box">
      <div :class="['step',stepIndex === 1?'active':'']"><img :src="editSvg" /><span>1.Personal Information</span></div>
      <div :class="['step2',stepIndex === 2?'active':'']"><img :src="videoSvg" />2.Self Introduction</div>
    </div>
    <el-form ref="infoForm" :model="infoForm" label-position="top">
      <!-- 基础信息填写 -->
      <div v-if="stepIndex === 1">
        <!-- doing currently -->
        <!-- <el-row>
          <el-col :span="20">
            <el-form-item label="1.What are you doing currently?" prop="current_career" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">
              <el-Select class="leapin-w-100" v-model="infoForm.current_career" placeholder="Please select">
                <el-option 
                  v-for="(item,index) in doingList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-Select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- 职业目标 -->
        <!-- <el-row>
          <el-col :span="20">
            <el-form-item label="2.What's your career objective?" prop="career_objective" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">
              <el-Select class="leapin-w-100" v-model="infoForm.career_objective" placeholder="Please select">
                <el-option 
                  v-for="(item,index) in careerList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-Select>
            </el-form-item>
          </el-col>
        </el-row> -->

        <!-- 姓名 -->
        <el-row :gutter="10">
          <el-col :span="10">
            <el-form-item label="1.First name" prop="first_name" :rules="[{ required: true, message: 'Please enter', trigger: 'blur' }]">
              <el-input placeholder="Please enter" v-model="infoForm.first_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="2.Last name" prop="last_name" :rules="[{ required: true, message: 'Please enter', trigger: 'blur' }]">
              <el-input placeholder="Please enter" v-model="infoForm.last_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 手机号 -->
        <el-row>
          <el-col :span="20">
            <el-form-item label="3.Mobile" prop="mobile" :rules="[{ required: true, message: 'Please enter', trigger: 'blur' }]">
              <el-row :gutter="10">
                <el-col :span="4">
                  <el-tooltip
                    :content="infoForm.mobile_country_code+'('+nowPrefixName+')'"
                    placement="top-start">
                    <el-select filterable v-model="infoForm.mobile_country_code" @change="changePrefixCode" placeholder="Select">
                      <el-option
                          v-for="(item, key) of phonePrefixCode"
                          :value="item.code"
                          :key="key"
                          :title="item.code+'('+item.en+')'"
                          :label="item.code+'('+item.en+')'"
                        >
                        {{ item.code+'('+item.en+')' }}
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-col>
                <el-col :span="6">
                  <el-input v-model="infoForm.mobile" placeholder="Please enter"></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 职位意向 -->
<!--        <el-row>-->
<!--          <el-col :span="20">-->
<!--            <el-form-item label="4.What kind of job are you looking for?" prop="intention_job_list" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">-->
<!--              <el-input clearable placeholder="Please enter and press enter to confirm" @blur="handleEnter(intentionInputValue,'intention_job_list')" v-model="intentionInputValue" @keyup.enter.native="handleEnter(intentionInputValue,'intention_job_list')"></el-input>-->
<!--            </el-form-item>-->
<!--            <div class="tags">-->
<!--              <el-tag-->
<!--                v-for="(tag, index) in infoForm.intention_job_list"-->
<!--                :key="index"-->
<!--                closable-->
<!--                @close="handleClose(tag,infoForm.intention_job_list)">-->
<!--                {{ tag }}-->
<!--              </el-tag>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <!-- 职业类型 -->
<!--        <el-row>-->
<!--          <el-col :span="20">-->
<!--            <el-form-item label="5.Job type" prop="job_type" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">-->
<!--              <el-checkbox-group v-model="jobTypeList" @change="changeJobType">-->
<!--                  <el-checkbox label="0">Full-time</el-checkbox>-->
<!--                  <el-checkbox label="1">Part-time</el-checkbox>-->
<!--                  <el-checkbox label="2">Intership</el-checkbox>-->
<!--                  <el-checkbox label="3">Contract</el-checkbox>-->
<!--                  <el-checkbox label="4">Freelancer</el-checkbox>-->
<!--                  <el-checkbox label="5">Other</el-checkbox>-->
<!--              </el-checkbox-group>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <!-- 地址 -->
        <el-row>
          <el-col :span="20">
            <el-form-item label="4.Location" prop="intention_address" :rules="[{ required: locationRadio == 'Onsite' ? true : false, message: 'Please select', trigger: 'change' }]">
              <el-radio-group @change="changeLocationRadio" v-model="locationRadio">
                <el-radio label="Onsite">Onsite</el-radio>
                <el-radio label="Remote">Remote</el-radio>
              </el-radio-group>
              <el-cascader
                v-if="locationRadio == 'Onsite'"
                :show-all-levels="false"
                @change="handleChange"
                placeholder="Please select"
                class="leapin-w-100"
                v-model="infoForm.intention_address"
                :props="{ value: 'label_en', label: 'label_en', multiple: true, checkStrictly: true }"
                :options="locationList">
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 公司规模 -->
        <!-- <el-row>
          <el-col :span="20">
            <el-form-item label="4.Your ideal company stage?">
              <el-Select clearable class="leapin-w-100" v-model="infoForm.company_stage" placeholder="Please select">
                <el-option 
                  v-for="(item,index) in comStageList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-Select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- 职业规划 -->
        <el-row>
          <el-col :span="20">
            <el-form-item label="5. Do you have your career goals? What do you hope to achieve in the next 3-5years?" prop="has_career_plan" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">
              <el-row :gutter="10">
                <el-col :span="3">
                  <el-Select class="leapin-w-100" v-model="infoForm.has_career_plan" placeholder="Please select">
                    <el-option label="Yes" :value="true"></el-option>
                    <el-option label="No" :value="false"></el-option>
                  </el-Select>
                </el-col>
                <el-col :span="21">
                  <el-input :disabled="infoForm.has_career_plan == false" placeholder="Please enter" v-model="infoForm.career_plan"></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 挑战 -->
        <el-row>
          <el-col :span="20">
            <el-form-item label="6.What's your challenges right now?" prop="challenges" :rules="[{ required: true, message: 'Please select', trigger: 'blur' }]">
              <el-Select class="leapin-w-100" multiple v-model="infoForm.challenges" placeholder="Please select">
                <el-option 
                  v-for="(item,index) in challengesList"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-Select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Link url -->
        <el-row>
          <el-col :span="20">
            <el-form-item label="7. Share with us your LinkedIn profile. ">
              <el-input placeholder="Please enter" v-model="infoForm.personal_website"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 爱好 -->
        <el-row>
          <el-col :span="20">
            <el-form-item label="8.Please describe your interests, hobbies, and strengths in one sentence. " prop="hobbies" :rules="[{ required: true, trigger: 'blur' }]">
              <el-input type="textarea" :rows="5" clearable placeholder="Please enter and press enter to confirm" v-model="infoForm.hobbies"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 上传个人简历 -->
<!--        <el-row>-->
<!--          <el-col :span="20">-->
<!--            <el-form-item label="11.Upload your cv" prop="cv_url" :rules="[{ required: true, message: 'Please upload', trigger: 'change' }]">-->
<!--              <div class="upload-box"  v-loading="cvUploading">-->
<!--                <input type="file" @change="handleFileUpload" />-->
<!--                <img :src="uploadSvg" alt="" />-->
<!--              </div>-->
<!--              <div v-if="fileName.length > 0" class="file-name">-->
<!--                <i class="el-icon-document"></i>  {{ fileName }}-->
<!--              </div>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </div>
      <!-- 视频录制 -->
      <div v-if="stepIndex === 2">
        <div class="web-video-answer" ref="affixWraper">
          <div class="web-video-answer-content">
            <div class="web-video-answer-box">
              <img src="@/assets/images/img_person.png" class="left" />
              <div class="right">
                <!-- 回答问题视频窗口 -->
                <div v-show="isStart || haveInroduceVideo" ref="videoAnswerPlayerWrap" class="video-window">
                  <div
                    v-if="!haveInroduceVideo"
                    :class="[
                      'leapin-w-100',
                      'leapin-h-100',
                      'leapin-bg-black',
                      'local-player-cls',
                    ]">
                    <div id="local-player" class="leapin-h-100"></div>
                  </div>
                  <video
                     v-else
                     controls
                     :src="infoForm.introduce_video_url"
                     type="video/mp4"
                     class="leapin-w-100 leapin-h-100 local-player-cls"
                     >
                  </video>
                </div>
                <div class="bottom" :class="[isStart? 'leapin-fs-14' : 'leapin-fs-18']">
                  Please use video to introduce yourself. 
                </div>
                <!-- 按钮 -->
                <!-- 开始回答 -->
                <el-button
                  @click="handleStart"
                  class="ans-button"
                  type="primary"
                  v-if="!isStart"
                  :loading="loading"
                  style="width: 100%;"
                  round>
                 {{ haveInroduceVideo == false ? 'Start': 'Re record' }}
                </el-button>
                <!-- 完成回答 -->
                <el-button
                  @click="handleFinish"
                  :loading="finishLoading"
                  :disabled="!isCanFinish"
                  type="primary"
                  class="ans-button"
                  v-else
                  style="width: 100%;"
                  round>
                  End
                </el-button>
                <el-row v-if="!isStart && !backDisabled && haveInroduceVideo == false" class="ans-skip">
                  <el-button @click="submitDisabled = false" type="text">Skip</el-button>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 按钮操作 -->
      <el-row :gutter="20">
        <div class="form-line">
          <el-col v-show="stepIndex === 1" :span="12" class="leapin-text-right">
            <el-button :loading="saveLoading" round @click="saveInfo()">Save</el-button>
          </el-col>
          <el-col v-show="stepIndex === 1" :span="12">
            <el-button type="primary" round @click="nextStep()">Next</el-button>
          </el-col>

          <el-col v-show="stepIndex === 2" :span="12" class="leapin-text-right">
            <el-button :disabled="backDisabled" round @click="upStep()">Back</el-button>
          </el-col>
          <el-col :span="12" v-show="stepIndex === 2">
            <el-button type="primary" :disabled="submitDisabled" round @click="submitInfo()">Submit And Get Match</el-button>
          </el-col>
        </div>
      </el-row>
    </el-form>

    
  </div>
</template>

<script>
import { addressList } from "@/services/address.js";
import newPhonePrefixCode from "@/constants/newPhonePrefixCode";
import {
  getAgoraChannelInfo,
  agoraRecordingStart,
  agoraRecordingStop,
  agoraRecordingSids,
} from "@/services/agora";
import { sendUserInfo, getUserInfo } from "@/services/user";
import { createAgoraPublish, handleAgoraChanelLeave } from "@/utils/agora";
import { CHALLENGES_CODE } from "@/constants/challenges";
import request from "@/utils/request";
export default {
  name: 'InfoForm',
  props: {
    editType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      submitDisabled: true,
      locationRadio: '1',
      phonePrefixCode: newPhonePrefixCode,
      nowPrefixName: 'China',
      jobTypeList: [],
      backDisabled: false,
      challengesList: CHALLENGES_CODE,
      cvUploading: false,
      //视频录制相关字段--start
      haveInroduceVideo: false,
      isStartFinishCountdown: false,
      isStart: false,
      isCanFinish: false,
      agoraStatusQuery: null,
      finishLoading: false,
      loading: false,
      saveLoading: false,
      agoraSid: null,
      videoEleW: null,
      videoEleH: null,
      videoEle: null,
      //视频录制相关字段--end
      uploadSvg: require('@/assets/images/users/upload.png'),
      editSvg: require('@/assets/svgs/edit-form.svg'),
      videoSvg: require('@/assets/svgs/video-form.svg'),
      stepIndex: 1,
      hobbiesInputValue: '',
      intentionInputValue: '',
      comStageList: [
        { label: 'EarlyStage', value: 0 },
        { label: 'GrowthStage', value: 1 },
        { label: 'LateStage', value: 2 },
        { label: 'PublicCompany', value: 3 },
      ],
      doingList: [
        { label: 'College student', value: 0 },
        { label: 'Working professional ', value: 1 },
        { label: 'Sabbatical or Carrer break ', value: 2 },
      ],
      careerList: [
        { label: 'Secure a new job', value: 0 },
        { label: 'Learn a new skills ', value: 1 },
        { label: 'Gain industry experience', value: 2 },
        { label: 'Growth in the currrent job ', value: 3 },
        { label: 'Job transition', value: 4 }
      ],
      locationList: [], //地址列表 用户自己保存过的 从后台获取
      submitLoading: false,
      infoForm: {
        first_name: '',
        last_name: '',
        mobile: '',
        mobile_country_code: '86',
        job_type: [], // # list 职位类型
        personal_website: "", // # 个人网站
        introduce_video_url: "", //# 录制完视频后调用的sids接口返回的signed_url
        current_career: undefined, // # 当前职业
        career_objective: undefined, // # 职业目标
        intention_job_list: [], // # list 求职意向
        challenges: [], // # list 挑战
        company_stage: undefined, // # 公司规模 0-EarlyStage 1-GrowthStage 2-lateStage 3-PublicCompany
        intention_address: [], // # 意向地址
        cv_url: "", // # 上传的cv文件， 此字段仅作为临时文件的key，上传成功后会返回一个cv_url
        career_plan: "", // # 职业规划
        has_career_plan: undefined, // # 是否有职业规划
        hobbies: '', // # list 爱好
      },
      file: null,
      fileName: ''
    }
  },
  mounted () {
    this.getAddressList()
    this.getReportInfo()
  },
  methods: {
    changeLocationRadio (val) {
      this.locationRadio = val
      this.infoForm.intention_address = []
    },
    changePrefixCode (val) {
      this.nowPrefixName = this.phonePrefixCode.filter(item => item.code === val)[0].en
    },
    upStep() {
      if (this.backDisabled) {
        return
      }
      this.stepIndex = 1
    },
    changeJobType(value) {
      this.infoForm.job_type = JSON.parse(JSON.stringify(value))
      this.infoForm.job_type = this.infoForm.job_type.map(item => {
        return parseInt(item)
      })
      console.log(this.infoForm.job_type)
    },
    saveInfo() {
      delete this.infoForm.id
      this.infoForm.is_completed = false
      this.saveLoading = true
      this.infoForm.intention_address = this.locationRadio == 'Remote' ? [['Remote']] : this.infoForm.intention_address
      sendUserInfo(this.infoForm).then(res => {
        if (res.code === 0) {
          this.saveLoading = false
          this.$message({
            message: 'Save successfully',
            type: 'success'
          });
        } else {
          this.saveLoading = false
          this.$message({
            message: res.code === 400 ? 'Mobile exists.' : 'Submit failed',
            type: 'error'
          });
        }
      }).catch(error => {
        this.saveLoading = false
        console.error('Submit error', error);
      });
    },
    //获取登陆人信息
    getReportInfo() {
      getUserInfo({}).then((res) => {
        if (res.code === 0 && res.data.extra_info) {
          this.infoForm = {
            ...this.infoForm,
            ...res.data.extra_info
          }
          this.infoForm.first_name = res.data.first_name
          this.infoForm.last_name = res.data.last_name
          this.infoForm.mobile = res.data.mobile
          this.infoForm.mobile_country_code = res.data.mobile_country_code
          this.locationRadio = JSON.stringify(res.data.extra_info.intention_address).indexOf('Remote') > -1 ? 'Remote' : 'Onsite'
          // job_type格式转换
          this.jobTypeList = JSON.parse(JSON.stringify(this.infoForm.job_type))
          this.jobTypeList= this.infoForm.job_type.map(item => {
            return String(item)
          })
          //this.intention_addressList = this.infoForm.intention_address.split('/')
          this.fileName = this.infoForm.cv_url.split('/').pop()
          this.haveInroduceVideo = this.infoForm.introduce_video_url != '' ? true : false;
          //this.isStart = this.infoForm.introduce_video_url != '' ? true : false;
        } else {
          // this.$message.error(res.message);
        }
      })
    },
    handleChange(value) {
      console.log(JSON.stringify(value));
      //this.infoForm.intention_address = value.join('/');
    },
    nextStep() {
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          this.saveInfo()
          this.stepIndex = 2
        } else {
          this.$emit('scrollToTop')
          return false;
        }
      });
    },
    // 视频录制--相关方法--start
    handleStart() {
      this.loading = true;
      this.haveInroduceVideo = false;
      this.backDisabled = true;
      getAgoraChannelInfo().then((res) => {
          if (res.code === 0) {
            createAgoraPublish(
              res.data.app_id,
              res.data.channel,
              res.data.token,
              res.data.uid,
              "local-player",
              () => {
                agoraRecordingStart({is_vertical: false,}).then((res) => {
                    this.loading = false;
                    this.isStart = true;
                    if (res) {
                      this.isStartFinishCountdown = true;
                      this.agoraSid = res.data.s_id;
                    }
                  }).catch(() => {
                    this.handleAgoraRecordingReset();
                  });
              },() => {
                
              }
            );
          } else {
            this.loading = false;
            
          }
        })
        .catch(() => {
          this.loading = false;
          
        });
    },
    // 完成录制
    handleFinish() {
      //this.$refs.countdownFinishRef.pause();
      this.finishLoading = true;
      this.stopTimer = setTimeout(() => {
        agoraRecordingStop({
          s_id: this.agoraSid,
        }).then((res) => {
            this.finishLoading = false;
            this.backDisabled = false;
            if (res) {
              handleAgoraChanelLeave("local-player");
              this.agoraSid = res.data.s_id;
              agoraRecordingSids({
                s_ids: [this.agoraSid],
              }).then((res) => {
                  this.loading = false;
                  if (res && res.data && res.data[0]) {
                    console.warn('录制结果为='+res.data[0].signed_url);
                    this.infoForm.introduce_video_url = res.data[0].signed_url;
                    this.haveInroduceVideo = true;
                    this.isStart = false;
                    this.submitDisabled = false;
                  } else {
                    this.handleAgoraRecordingReset();
                  }
                })
                .catch(() => {
                  this.finishLoading = false;
                  this.backDisabled = false;
                  this.handleAgoraRecordingReset();
                });
            } else {
              this.finishLoading = false;
              this.backDisabled = false;
              this.handleAgoraRecordingReset();
            }
          })
          .catch(() => {
            this.finishLoading = false;
            this.backDisabled = false;
            this.handleAgoraRecordingReset();
          });
      }, 1000);
    },
    // 开始录制--end




    handleEnter(value,list) {
      console.log(JSON.stringify(this.infoForm))
      if (value.trim()) {
        if (list == 'intention_job_list') {
          this.infoForm.intention_job_list.push(value.trim());
          this.intentionInputValue = ''; // 清空输入框
        }
      }
    },
    handleClose(tag, list) {
      const index = list.indexOf(tag);
      if (index !== -1) {
        list.splice(index, 1); // 从标签数组中移除标签
      }
    },
    // 获取地址列表
    getAddressList() {
      addressList({page:1,page_size:100}).then(res => {
        this.locationList = res.data.results
      })
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.fileName = this.file.name;
      console.log('文件', this.file);
      this.cvUploading = true;
      let formData = new FormData();
      formData.append('cv_file', this.file);
      request({
        url: '/users/me/upload/cv/',
        method: "post",
        data: formData,
      }).then((res) => {
        if (res) {
          this.cvUploading = false;
          this.infoForm.cv_url = res.data.cv_url;
        }
      }).catch(error => {
        console.error('文件上传失败', error);
      });
    },

    // 提交表单
    submitInfo() {
      this.submitLoading = true
      delete this.infoForm.id
      this.infoForm.is_completed = true
      this.infoForm.intention_address = this.locationRadio == 'Remote' ? [['Remote']] : this.infoForm.intention_address
      sendUserInfo(this.infoForm).then(res => {
        if (res.code === 0) {
          this.submitLoading = false
          this.$message({
            message: 'Submit successfully',
            type: 'success'
          });
          if (this.editType == 1) {  //表示是修改页面
            this.$emit('updateInfo')
          } else {
            //获取登陆人信息后进行跳转
            getUserInfo({}).then((res) => {
              if (res.code === 0) {
                this.$store.dispatch("user:userinfo", res.data);
                this.$emit('routerChange')
              }
            })
            //this.$router.push({ path: '/CandidateReport' })
          }
        } else {
          this.submitLoading = false
          this.$message({
            message: res.code === 400 ? 'Mobile exists.' : 'Submit failed',
            type: 'error'
          });
        }
      }).catch(error => {
        this.submitLoading = false
        console.error('Submit error', error);
      });
    }



  }
}
</script>
<style scoped lang="scss">
.form-area {
  margin-top: 20px;
  padding: 32px 52px 64px 52px;
  border-radius: 32px;
  background: #FFF;
  .steps-box {
    padding: 0 20%;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    .step {
      min-width: 150px;
      display: flex;
      padding: 12px 16px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 8px 0px 0px 8px;
      background: #C5C0F5;
    }
    .step2 {
      min-width: 140px;
      display: flex;
      width: 168px;
      padding: 12px 8px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 0px 8px 8px 0px;
      background: #C5C0F5;
    }
    .active { background: #6E62E5 !important; }
  }
  .form-line {
    border-top: 2px solid #E6E8F0;
    padding-top: 32px;
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
  }
  .el-tag {
    border-radius: 1px !important;
    background: rgba(110, 98, 229, 0.15) !important;
    color: #6E62E5 !important;
    border: 1px solid rgba(110, 98, 229, 0.15) !important;
  }
  .upload-box {
    width: 260px;
    height: 145px;
    border-radius: 6px;
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 260px;
      height: 145px;
      object-fit: contain;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      position: relative;
      z-index: 2;
    }
  }

  .web-video-answer {
    background: rgba(0, 0, 0, .04);
    display: flex;
    justify-content: center;
    align-items: center;
    .web-video-answer-content {
      width: 800px;
      box-shadow: 0 4px 16px 0 #d9d9d9;
      margin: 40px auto 40px;
      .web-video-answer-box {
        padding: 0px 40px;
        min-height: 583px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0 40px;
        .left {
          width: 320px;
          height: 483px;
          object-fit: cover;
        }
        .right {
          flex: 1;
          height: 487px;
          position: relative;
          .top {
            font-weight: 600;
            color: #000;
            .clock {
              float: right;
              img {
                width: 15px;
                height: auto;
                margin-right: 5px;
              }
            }
          }
          .bottom {
            font-weight: 600;
            margin: 10px 0;
            color: #000;
          }
          .video-window {
            //width: 360px;
            height: 280px;
            margin-bottom: 20px;
          }
          .down-time {
            font-size: 14px;
          }
        }
        .ans-skip {
          width: 100%;
          position: absolute;
          bottom: -40px;
          right: 0px;
          text-align: center;
        }
        .ans-button {
          width: 200px;
          border-radius: 3px;
          font-size: 18px;
          position: absolute;
          bottom: 0px;
          right: 0px;
          background: linear-gradient(to right, #2257bf, #2257bf);
          color: #fff;
        }

      }
    }
  }
}
</style>
